export default __webpack_public_path__ + "static/media/background2.e80c7b4f.jpg";